import Link from "next/link";
import { IZone } from "@nju/data-access-portal-dashboard";
import { ErrorMessage } from "@nju/form";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import {
  A,
  BlockText,
  Button,
  ButtonsWrapper,
  Circle,
  Heading,
  Separator,
  Text,
} from "@nju/ui";
import { formatPrice, parseSecondsToMinutes } from "@nju/utils";
import { NoFundsButtons } from "../../../shared";

interface ISummaryProps {
  userId: string | undefined;
  isBuying: boolean;
  isReady: boolean;
  addAdditionalPackage: () => void;
  zone: IZone["name"];
  country: string;
  productOfferPrice: number;
  productOfferGrantValue: string;
  hasNoFunds: boolean;
  hasOrderInProgress: boolean;
  zoneName: string | undefined;
}

export function Summary({
  userId,
  isBuying,
  isReady,
  addAdditionalPackage,
  zone,
  country,
  productOfferPrice,
  productOfferGrantValue,
  hasNoFunds,
  hasOrderInProgress,
  zoneName,
}: ISummaryProps) {
  return (
    <div>
      <Heading font="ttfirs" tone="neutral" variant="h2" weight="bold">
        podsumowanie
      </Heading>
      <Separator size="xs" tone="invisible" />
      <BlockText
        className="from-tablet:max-w-[630px]"
        size={{ "@onlyMobile": "s", "@fromTablet": "l" }}
      >
        Połączenia są rozliczane sekundowo. Minuta połączenia jest wymienna w
        stosunku 1 : 1 z SMS lub z MMS wychodzącym.
      </BlockText>
      <Separator size="xs" tone="invisible" />
      <Text
        display="block"
        size={{ "@onlyMobile": "xl", "@fromTablet": "keyS" }}
        tone="accent"
        weight="bold"
      >
        {zoneName}
      </Text>
      <Separator size="xs" tone="invisible" />
      <Text display="block" size={{ "@onlyMobile": "s", "@fromTablet": "l" }}>
        W ramach tej strefy, z pakietu możesz korzystać jeszcze w wielu innych
        krajach.
      </Text>
      <Separator size="xxs" tone="invisible" />
      <Link
        href={portalRoutes.mojeKonto.uslugiDodatkowe.rozmowyMiedzynarodowe.strefy.get(
          {
            ...(userId && { userId }),
            country,
            zone,
          },
        )}
        passHref={true}
      >
        <A display="block" size="inline" variant="neutral">
          <Text withUnderline={true}>sprawdź</Text>
        </A>
      </Link>
      <Separator size="m" />
      <Text display="block" size={{ "@onlyMobile": "s", "@fromTablet": "m" }}>
        wybrany kraj
      </Text>
      <Text
        display="block"
        size={{ "@onlyMobile": "s", "@fromTablet": "l" }}
        weight="bold"
      >
        {country}
      </Text>
      <Separator size="m" />
      <Separator size="s" tone="invisible" />
      <div
        className="px-6 py-4 border-2 border-geyser max-w-fit rounded-[12px] flex items-center gap-6"
        data-cy="voice-package-panel-summary"
      >
        <Circle className="w-8 h-8" tone="accent">
          <Icon height={15} name="phone" tone="secondary" width={15} />
        </Circle>
        <div>
          <Text
            display="block"
            size={{ "@onlyMobile": "m", "@fromTablet": "xl" }}
            weight="bold"
          >
            {parseSecondsToMinutes(productOfferGrantValue)} min./SMS/MMS
          </Text>
          <Text
            display="block"
            size={{ "@onlyMobile": "m", "@fromTablet": "xl" }}
            tone="accent"
            weight="bold"
          >
            {formatPrice(productOfferPrice)} zł
          </Text>
        </div>
      </div>
      {hasOrderInProgress && (
        <>
          <Separator size="xxs" tone="invisible" />
          <ErrorMessage message="Zamówienie w toku. Poczekaj na włączenie pakietu." />
        </>
      )}
      <Separator size="s" tone="invisible" />
      {(isReady || isBuying) && (
        <ButtonsWrapper>
          <Link
            href={portalRoutes.mojeKonto.index.get({
              mode: "mobile",
              ...(userId && { userId }),
            })}
            passHref={true}
          >
            <A
              size={{
                "@onlyMobile": "s",
              }}
              variant="secondary"
            >
              anuluj
            </A>
          </Link>
          <Button
            isLoading={isBuying}
            onPress={addAdditionalPackage}
            size={{
              "@onlyMobile": "s",
            }}
          >
            kup
          </Button>
        </ButtonsWrapper>
      )}
      {hasNoFunds && <NoFundsButtons />}
      {hasOrderInProgress && (
        <>
          <Separator size="m" thickness="thin" />
          <Button
            onPress={() => {
              return window.location.reload();
            }}
            size={{
              "@onlyMobile": "s",
            }}
          >
            ok
          </Button>
        </>
      )}
    </div>
  );
}
